import {
  FetchResult,
  gql,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationResult,
  TypedDocumentNode,
  useMutation,
} from '@apollo/client';
import { Interval, toDate } from 'date-fns';
import {
  ForecastSliceInput,
  Resolution,
  SetForecastDataMutation,
  SetForecastDataMutationVariables,
} from '../../../../../generated/graphql';

export const forecastDataMutation: TypedDocumentNode<SetForecastDataMutation, SetForecastDataMutationVariables> = gql`
  mutation SetForecastData(
    $device: ID!
    $interval: IntervalInput!
    $resolution: Resolution!
    $slices: [ForecastSliceInput!]!
  ) {
    updateForecast(device: $device, interval: $interval, resolution: $resolution, slices: $slices) {
      id
      date
      hasDowntime
      fields {
        type
        watt
      }
    }
  }
`;

export function useForecastDataMutation(
  options?: MutationHookOptions<SetForecastDataMutation, SetForecastDataMutationVariables>,
): [
  (
    device: string,
    interval: Interval,
    slices: readonly ForecastSliceInput[],
    resolution?: Resolution,
    opts?: MutationFunctionOptions<SetForecastDataMutation, SetForecastDataMutationVariables>,
  ) => Promise<FetchResult<SetForecastDataMutation>>,
  MutationResult<SetForecastDataMutation>,
] {
  const [update, data] = useMutation(forecastDataMutation, options);

  return [
    (device, interval, slices, resolution, opts) =>
      update({
        ...opts,
        variables: {
          device,
          interval: {
            start: toDate(interval.start),
            end: toDate(interval.end),
          },
          resolution: resolution ?? Resolution.ONE_HOUR,
          slices,
        },
      }),
    data,
  ];
}
